export default "__VITE_ASSET__68adeaeb__"